export default "__VITE_ASSET__DOn95hQq__"